var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMergeRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 2.5H27.5M32.5 24.5H27.5M27.25 2.5L27.25 24.5",
    stroke: "#1F4B82",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5H17.5M12.5 24.5H17.5M17.75 2.5L17.75 24.5",
    stroke: "#1F4B82",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3793 14.2632C14.5232 14.1172 14.5232 13.8828 14.3793 13.7368L8.38299 7.65162C8.14756 7.4127 7.74088 7.57941 7.74088 7.91483L7.74088 20.0852C7.74088 20.4206 8.14756 20.5873 8.38299 20.3484L14.3793 14.2632Z",
    fill: "#AD2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4964 11.7839C11.4964 11.5768 11.3285 11.4089 11.1214 11.4089H0.656934C0.294119 11.4089 0 11.3704 0 11.7763V15.8101C0 16.0172 0.167873 16.1851 0.374981 16.1851C0.439627 16.1851 0.519988 16.1851 0.656934 16.1851H11.1214C11.3285 16.1851 11.4964 16.0172 11.4964 15.8101V11.7839Z",
    fill: "#AD2F2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6207 14.2632C30.4768 14.1172 30.4768 13.8828 30.6207 13.7368L36.617 7.65162C36.8524 7.4127 37.2591 7.57941 37.2591 7.91483L37.2591 20.0852C37.2591 20.4206 36.8524 20.5873 36.617 20.3484L30.6207 14.2632Z",
    fill: "#AD2F2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5036 11.7839C33.5036 11.5768 33.6715 11.4089 33.8786 11.4089H44.3431C44.7059 11.4089 45 11.3704 45 11.7763V15.8101C45 16.0172 44.8321 16.1851 44.625 16.1851C44.5604 16.1851 44.48 16.1851 44.3431 16.1851H33.8786C33.6715 16.1851 33.5036 16.0172 33.5036 15.8101V11.7839Z",
    fill: "#AD2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeRole);
export default __webpack_public_path__ + "static/media/merge_role.65c20c53db71bae2d0c3e51f4168d8f3.svg";
export { ForwardRef as ReactComponent };